import { HTMLAttributes, PropsWithChildren } from 'react';
import cls from 'classnames';

import styles from './Alert.module.css';

export type AlertType = 'warning' | 'danger' | 'success' | 'info';

export const ALERT_WARNING: AlertType = 'warning';
export const ALERT_DANGER: AlertType = 'danger';
export const ALERT_SUCCESS: AlertType = 'success';
export const ALERT_INFO: AlertType = 'info';

const TYPE_CLASS_MAP = {
  [ALERT_WARNING]: styles.alertWarning,
  [ALERT_DANGER]: styles.alertDanger,
  [ALERT_SUCCESS]: styles.alertSuccess,
  [ALERT_INFO]: styles.alertInfo,
};

interface AlertProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  type: AlertType;
  title?: string;
  rounded?: boolean;
}

export default function Alert(props: PropsWithChildren<AlertProps>) {
  const { title = '', rounded = false, type = ALERT_WARNING, className, children, ...rest } = props;

  return (
    <div className={cls(styles.alert, { [styles.rounded]: rounded }, TYPE_CLASS_MAP[type], className)} {...rest}>
      {title && <strong>{`${title} `}</strong>}

      {children}
    </div>
  );
}
